export { default } from './rooms';
